import PubSub from "pubsub-js";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CONSTANTS, MAINMENU, NOTIFY, PLATFORM, STATUS_ACTIVE } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import CheckBox from "../../based/inputs/CheckBox";
import Loading from "../../based/Loading";
import { Notify } from "../../based/Notify";
import PlatformServices from "../../based/services/PlatformServices";
export default function LazadaConfig(props) {
    const [isBusy, setBusy] = useState(true);
    const history = useHistory();
    const [message, setMessage] = useState("Đang tải dữ liệu...");
    const [stores, setStores] = useState([]);
    const [storeSelected, setStoreSelected] = useState(null);

    useEffect(() => {
        connnect();
        PubSub.publish(CONSTANTS.SIDEBAR_MENU_TOPIC, { mainMenu: MAINMENU.ConnectPlatform });
    }, []);

    async function connnect() {
        let fullParamUrl = window.location.search;
        if (fullParamUrl && fullParamUrl.indexOf("code=") > -1) {
            setBusy(true);
            setMessage("Đang tải dữ liệu..");
            const [err, data] = await PlatformServices.ConnectToPlatform(fullParamUrl);
            if (!err) {
                setBusy(false);
                setMessage("");
                props.history.push("/connect-platform-config/lazada");
            } else {
                setBusy(false);
                setMessage("");
            }
            _getStores();
        } else {
            _getStores();
        }
    }

    async function _handleConnectToLazada() {
        setBusy(true);
        setMessage("Đang kết nối...");
        const [err, data] = await PlatformServices.ConnectToPlatform(`?platform=${PLATFORM.Lazada}`);
        if (!err) {
            window.location.href = data;
            setBusy(false);
            setMessage("");
        } else {
            setBusy(false);
            setMessage("");
        }
    }

    async function _getStores() {
        setBusy(true);
        setMessage("Đang tải dữ liệu..");
        const [err, data] = await PlatformServices.PlatformStoresUser([PLATFORM.Lazada], STATUS_ACTIVE.All);
        if (!err) {
            setStores(data);
            setBusy(false);
            setMessage("");
        } else {
            setBusy(false);
            setMessage("");
        }
    }
    async function _handleRemoveStore(store) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn xóa kết nối đến gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                setMessage("Đang xóa dữ liệu..");
                const [err, data] = await PlatformServices.DeleteConnectStore(store.id);
                if (!err) {
                    if (data) {
                        resolve({ title: "Thành công", msg: "Xóa kết nối gian hàng thành công" });
                        let storesUpdate = [...stores];
                        let idx = -1;
                        storesUpdate.map((item, i) => {
                            if (item.id == store.id) idx = i;
                        });
                        if (idx > -1) storesUpdate.splice(idx, 1);
                        setStores(storesUpdate);
                    } else {
                        reject(err);
                    }
                    setBusy(false);
                    setMessage("");
                } else {
                    Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                    setBusy(false);
                    setMessage("");
                }
            });
        });
    }

    async function _handleRefreshToken(store) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn kết nối lại gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                setMessage("Đang kết nối gian hàng..");
                const [err, data] = await PlatformServices.RefreshAccessToken({ id: store.id, shopId: store.shopId, platform: PLATFORM.Lazada });
                if (!err) {
                    resolve({ title: "Thành công", msg: "Kết nối gian hàng thành công" });
                    _getStores();
                    setBusy(false);
                    setMessage("");
                } else {
                    reject({ title: "Có lỗi", msg: err.data ? err.data : CONSTANTS.MSG_ERROR });
                    setBusy(false);
                    setMessage("");
                }
            });
        });
    }

    async function _syncCat(model) {
        const [err, data] = await PlatformServices.SyncCategories(model);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Đồng bộ danh mục thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Đồng bộ danh mục thất bại");
        }
    }

    async function _syncSeller(platform) {
        const [err, data] = await PlatformServices.SyncSeller(platform);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Đồng bộ danh mục thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Đồng bộ danh mục thất bại");
        }
    }

    async function _handleActiveStore(platform, shop, isActive) {
        const [err, data] = await PlatformServices.UpdateSetIsActiveShop(platform, shop, isActive);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật trạng thái gian hàng thành công");
            _getStores();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Cập nhật trạng thái gian hàng thất bại");
        }
    }

    function _renderTable() {
        return stores && stores.length > 0 ? (
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <table className="tablesaw table mb-0 tablesaw-stack">
                        <thead>
                            <tr>
                                <th>Mã gian hàng (Shop Id)</th>
                                <th>Gian hàng (Shop Name)</th>
                                <th>Mã Seller (Seller Id)</th>
                                <th>Trạng thái</th>
                                <th>Ngày kết nối</th>
                                <th>Ngày hết hạn</th>
                                <th>Hoạt động</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {stores.map((store, k) => {
                                return (
                                    <tr key={k} className={storeSelected && storeSelected.shopName == store.shopName ? "tr_selected" : ""}>
                                        <td className="vertical-align-middle">
                                            <strong className="store-name" onClick={() => setStoreSelected(store)}>
                                                {store.shopId}
                                            </strong>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <strong className="store-name" onClick={() => setStoreSelected(store)}>
                                                {store.shopName}
                                            </strong>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <span className="store-seller-id" onClick={() => setStoreSelected(store)}>
                                                {store.sellerId}
                                            </span>
                                        </td>
                                        <td className="vertical-align-middle">{!store.isExpired ? <span className="label label-table label-success"> Đang hoạt động </span> : <span className="label label-table label-danger">Hết hạn</span>}</td>
                                        <td className="vertical-align-middle">
                                            <span>{store.connectDate}</span>
                                        </td>
                                        <td className="vertical-align-middle">{store.connectDateExpires ? <span>{store.connectDateExpires}</span> : null}</td>
                                        <td className="vertical-align-middle">
                                            <CheckBox
                                                name={`isActive_${store.id}`}
                                                checked={store.isActive}
                                                onCheckedChange={(name, value) => {
                                                    _handleActiveStore(PLATFORM.Lazada, store.shopId, value);
                                                }}
                                                label="Kích hoạt"
                                            />
                                        </td>
                                        <td className="vertical-align-middle">
                                            <button className="btn btn-custom btn-sm m-r-5" onClick={() => _handleRefreshToken(store)}>
                                                <i className="fa fa-refresh"> Kết nối lại</i>
                                            </button>
                                            <button
                                                className="btn btn-custom btn-sm m-1"
                                                onClick={(e) => {
                                                    history.push(`/platform-shop-management/${store.shopId}/${PLATFORM.Lazada}`);
                                                }}
                                            >
                                                Chi tiết
                                            </button>

                                            <button className="btn btn-danger btn-sm" onClick={() => _handleRemoveStore(store)}>
                                                <i className="fa fa-trash-o"></i>
                                            </button>

                                            <button
                                                className="btn btn-custom btn-sm m-1"
                                                onClick={(e) => {
                                                    _syncCat({ platform: PLATFORM.Lazada, shopId: store.shopId });
                                                }}
                                            >
                                                Đồng bộ ngành hàng
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        ) : null;
    }
    return (
        <React.Fragment>
            <Loading show={isBusy} msg={message} />
            <div className="row">
                <div className="col-sm-12 form-row card-box p-3">
                    <div className="col-12 col-lg-12">
                        <button className="btn btn-custom m-2" onClick={() => _handleConnectToLazada()}>
                            <span>
                                <i className="fa fa-share-alt"></i> Kết nối kênh bán hàng
                            </span>
                        </button>

                        <button
                            className="btn btn-info m-2"
                            onClick={(e) => {
                                _syncSeller(PLATFORM.Lazada);
                            }}
                        >
                            <span>Đồng bộ SellerId</span>
                        </button>
                        <hr />
                        {_renderTable()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
